import {
  EmergencyScenarioFiltersInput,
  EmergencyScenarioLabelFragment,
  EmergencyScenarioLabelFragmentDoc,
  EmergencyScenarioStatus,
  EmergencyScenarioUniqueLabelFragment,
  EmergencyScenarioUniqueLabelFragmentDoc,
} from '../../graphql/api/generated';
import { PermissionKey_enum } from '../../graphql/hasura/generated';
import { Model } from '../Model';

export const EmergencyScenarioModel = new Model<
  EmergencyScenarioFiltersInput,
  EmergencyScenarioLabelFragment,
  EmergencyScenarioUniqueLabelFragment
>({
  names: {
    schemaName: 'EmergencyScenario',
    displayName: 'Emergency Scenario',
    pluralDisplayName: 'Emergency Scenarios',
  },
  permissionsOptions: {
    // Bypass introspection check (queries will be made to Main API rather than Hasura)
    canRead: ({ hasPermission }) => hasPermission(PermissionKey_enum.EmergencyScenario_Read),
    canCreate: ({ hasPermission }) => hasPermission(PermissionKey_enum.EmergencyScenario_Manage),
    canUpdate: ({ hasPermission }) => hasPermission(PermissionKey_enum.EmergencyScenario_Manage),
    canUpdateRow: ({ hasPermission }, { status }) => (
      hasPermission(PermissionKey_enum.EmergencyScenario_Manage) &&
      status === EmergencyScenarioStatus.INACTIVE
    ),
  },
  labels: {
    getLabel: e => e.name,
    getUniqueLabel: e => `${e.property.name} - ${e.name}`,
    labelFragment: EmergencyScenarioLabelFragmentDoc,
    uniqueLabelFragment: EmergencyScenarioUniqueLabelFragmentDoc,
  },
  queryOptions: {
    getTableSearchConditions: (words) => ({
      searchTerms: words,
    }),
  },
});

export default EmergencyScenarioModel;
